import { AxiosGlobal } from "../shared/axios";
import { AxiosPromise } from "axios";
import configs from "../../configs";
import { store } from "../../Components/store/store";



export class AuthLiveApis extends AxiosGlobal {

    loginUser(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/${configs.apiList.LOGIN}`, data);
    }


    registerUser(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/signup`, data);
    }


    forgotPassword(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/forgot-password`, data);
    }


    verifyMail(data: any): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/verify-email/${data}`,{
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    verifyResetToken(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/verify-reset-token`,data,{
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    

    resetPassword(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/reset-password`, data,{
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    logout(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/logout`, data, {
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }
   

    sendMail(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/send-mail`, data, {
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    createAgent(data:any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/create-agent`,data,{
            headers: { "Content-Type": "aplication/json","Accept":"aplication/json","Authorization":`Bearer ${store.getState().data.login.value.token}`,"Access-Control-Allow-Origin":"*" },
          });
    }

   


    


}